import {Component, EventEmitter, Output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CognitoService} from '../../../core/auth/cognito.service';
import {HttpErrorService} from '../../../core/services/http-error.service';
import {CustomInputComponent} from '../../../components/custom-input/custom-input.component';
import {ButtonComponent} from '../../../components/button/button.component';
import {QRCodeComponent} from 'angularx-qrcode';
import {confirmSignIn} from 'aws-amplify/auth';
import {AppAuthorizationService} from '../../../core/auth/app-authorization.service';
import {CognitoOrgIdService} from '../../../core/auth/cognito-org-id.service';
import {
  LABEL_CONSTANT,
  MFA_SETUP_CONSTANT,
  PLACEHOLDER_CONSTANT,
  VALIDATION_ERROR_CONSTANT
} from '../../../constant/constant';

@Component({
  selector: 'app-mfa-prompt',
  standalone: true,
  imports: [
    CustomInputComponent,
    ReactiveFormsModule,
    ButtonComponent,
    QRCodeComponent,
  ],
  templateUrl: './mfa-prompt.component.html',
  styleUrl: './mfa-prompt.component.scss'
})
export class MfaPromptComponent {

  @Output() setSignInState: EventEmitter<string> = new EventEmitter<string>();
  @Output() routeToApplicationGettingDefaultOrgDetails: EventEmitter<void> = new EventEmitter<void>();

  MFA_SETUP_CONSTANT = MFA_SETUP_CONSTANT;
  VALIDATION_ERROR_CONSTANT = VALIDATION_ERROR_CONSTANT;
  LABEL_CONSTANT = LABEL_CONSTANT;
  PLACEHOLDER_CONSTANT = PLACEHOLDER_CONSTANT;
  mfaPromptForm: FormGroup;
  isVerifying = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _cognitoService: CognitoService,
    private _httpErrorService: HttpErrorService,
    private _appAuthorizationService: AppAuthorizationService,
    private _cognitoOrgIdService: CognitoOrgIdService
  ) {
    this.mfaPromptForm = this._formBuilder.group({
      verificationCode: ['', [
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ]]
    });
  }

  async onVerify(): Promise<void> {
    if (this.mfaPromptForm.valid && !this.isVerifying) {
      this.isVerifying = true;
      try {
        const code = this.mfaPromptForm.get('verificationCode')?.value;
        const isVerified = await confirmSignIn({challengeResponse: code})
        if (isVerified.nextStep.signInStep === 'DONE') {
          this.routeToApplicationGettingDefaultOrgDetails.emit();
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          this._httpErrorService.httpError.set(error.message);
        }
      } finally {
        this.isVerifying = false;
      }
    }
  }
}
